import store from '@js/store'

export default [
    {
        path: 'available_properties',
        name: 'appUtilityAvailableProperty',
        redirect: { name: 'appUtilityAvailablePropertyList' },
        meta: { 
            title: 'utility.available_property.available_properties', 
            icon: 'fas fa-building',
            hideChildren: true,
            isNotNav: false,
            permissions: ['access-available_property']
        },
        beforeEnter: ((to, from, next) => {
            if( 0 && !store.getters['config/configs'].system.available_property) {
                next({ name: 'appDashboard'})
            } else {
                next()
            }
        }),
        component: {
            template: '<router-view></router-view>'
        },
        children: [
            {
                path: '',
                name: 'appUtilityAvailablePropertyList',
                meta: { 
                    trans: 'global.list',
                    title: 'utility.available_property.available_properties',
                },
                component: () => import('@views/app/utility/available_property/index' /* webpackChunkName: "js/app/utility/available_property/index" */),
            },
            {
                path: 'add',
                name: 'appUtilityAvailablePropertyAdd',
                meta: { 
                    trans: 'global.add',
                    title: 'utility.available_property.available_property',
                },
                component: () => import('@views/app/utility/available_property/add' /* webpackChunkName: "js/app/utility/available_property/add" */),
            },
            {
                path: ':uuid/edit',
                name: 'appUtilityAvailablePropertyEdit',
                meta: { 
                    trans: 'global.edit',
                    title: 'utility.available_property.available_property',
                },
                component: () => import('@views/app/utility/available_property/edit' /* webpackChunkName: "js/app/utility/available_property/edit" */),
            },
            {
                path: ':uuid/edit_gallery',
                name: 'appUtilityAvailablePropertyEditGallery',
                meta: { 
                    trans: 'utility.available_property.props.featured_image',
                    title: 'utility.available_property.available_property',
                },
                component: () => import('@views/app/utility/available_property/edit_gallery' /* webpackChunkName: "js/app/utility/available_property/edit_gallery" */),
            },
            {
                path: ':uuid',
                name: 'appUtilityAvailablePropertyView',
                meta: { 
                    trans: 'global.view',
                    title: 'utility.available_property.available_property',
                },
                component: () => import('@views/app/utility/available_property/view' /* webpackChunkName: "js/app/utility/available_property/view" */),
            }
        ]
    },
]